import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
// Ngb
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';

// Servicio
import { EmpleadosServicio } from '../../../services/empleado.service';
import { ClientesService } from '../../../services/Clientes.service';
import { PrestamosService } from '../../../services/prestamos.service';

import { Helper } from '../../../helpers/helper';
import { AlertasModales } from '../../../helpers/alertasModales';

@Component({
  selector: 'app-descuento-cuota',
  templateUrl: './descuento-cuota.component.html',
  styleUrls: ['./descuento-cuota.component.css']
})
export class DescuentoCuotaComponent implements OnInit {
  @Input() datosCliente: any;
  @Input() modals: AlertasModales;
  @Input() prestamoSeleccionado: number;
  @ViewChild('file') file: ElementRef;

  Math: Math;
  capital;
  cuotas: Array<any> = [];
  prestamoCliente: any;
  cargoMora = 0;
  form: FormGroup;
  resumenPrestamoDetalles = false;
  cuotaAfectadasDetalle: string;
  prestamoClienteTemp: any;

  constructor(public activeModal: NgbActiveModal,
    private clientesService: ClientesService,
    private prestamoService: PrestamosService,
    private empleadoService: EmpleadosServicio,
    private helper: Helper
  ) {}

  ngOnInit() {
    // Inicializar el formulario
    this.form = new FormGroup({
      'clienteID': new FormControl(this.datosCliente.ID_CLIENTE),
      'prestamo': new FormControl(this.prestamoSeleccionado, Validators.required),
      'nombreCliente': new FormControl({value: '', disabled: true}, Validators.required),
      'documentos': new FormArray([]),
      'cedulaCliente': new FormControl({value: '', disabled: true}),
      'montoDescuento': new FormControl('', Validators.required),
      'detalleDescuento': new FormControl({value: '', disabled: false}, Validators.required),
      'empleado': new FormControl('')
    });

    this.onChangePrestamo();
  }

  initClientePrestamoData(event) {

    // console.log('CONtenido', event);

    this.clientesService.descuentoPrestamoCuotaInfo(event.PRESTAMO_ID, event.CLIENTE_ID).subscribe(( res: any ) => {
      if (res) {
        // console.log( res );
        this.prestamoCliente = res;
        this.prestamoClienteTemp = res;
        this.form.get('nombreCliente').setValue( (res.nombre + ' ' + res.apellido ) || '');
        this.form.get('cedulaCliente').setValue( res.cedula || '');
        this.resumenPrestamoDetalles = true;
        this.cargoMora = res.datos_prestamo.cuotas.reduce( (a, b) => a + b.mora, 0);
      } else {
        this.resumenPrestamoDetalles = false;
        this.form.get('nombreCliente').setValue('');
        this.form.get('cedulaCliente').setValue('');
      }
    });

  }

  /**
   * Búsqueda de préstamo cuando cambia el DropDownList [prestamo]
   * @author Pedro Reinoso
   */
  onChangePrestamo() {
    const clienteDESC = {
      CLIENTE_ID: this.datosCliente.ID_CLIENTE,
      PRESTAMO_ID: this.form.get('prestamo').value
    };
    this.initClientePrestamoData( clienteDESC );
  }


  onChangeVerificaCuotasDescuento() {


    // console.log( this.prestamoClienteTemp.datos_prestamo );
    const prestamoCuotas = this.prestamoClienteTemp.datos_prestamo.cuotas;
    let montoDescontarTmp = this.form.get('montoDescuento').value;
    // tslint:disable-next-line:max-line-length
    if (montoDescontarTmp > this.prestamoCliente.datos_prestamo.capital + this.prestamoCliente.datos_prestamo.totalInteres - this.prestamoCliente.datos_prestamo.total_pagado) {
    // tslint:disable-next-line:max-line-length
    this.form.get('montoDescuento').setValue(this.prestamoCliente.datos_prestamo.capital + this.prestamoCliente.datos_prestamo.totalInteres - this.prestamoCliente.datos_prestamo.total_pagado);
    }
    // tslint:disable-next-line:max-line-length
    this.cuotaAfectadasDetalle = `Descuento al préstamo No. ${ this.prestamoClienteTemp.datos_prestamo.ID_PRESTAMO } para afectar la cuota No. `;


    let pos = 0;

    for (const cuota of prestamoCuotas) {
      const montoPagar = (cuota.monto_cuota - cuota.total_pagado); // + cuota.mora;
      // console.log( `monto_descontar = ${montoDescontarTmp}`);
      if ( montoDescontarTmp >= 1 && cuota.estado !== 2 ) {
        // console.log( ' VAMOS A DESCONTAR LA CUOTA ' + cuota.numero_cuota );

        // tslint:disable-next-line:triple-equals
        if (montoDescontarTmp == montoPagar) {
          // this.prestamoClienteTemp.datos_prestamo.cuotas[pos].total_pagar_con_mora = montoPagar;
          montoDescontarTmp = 0; // EN  0 PARA QUE NO SIGA DESCONTANDO CUOTAS
          // console.error(`IF 1: ahora monto_descontar = ${montoDescontarTmp}`);
        } else if (montoDescontarTmp > montoPagar) {
          montoDescontarTmp = montoDescontarTmp - montoPagar;
          // console.log(`IF 2: ahora monto_descontar = ${montoDescontarTmp}`);
        } else {
          montoDescontarTmp = 0; // EN  0 PARA QUE NO SIGA DESCONTANDO CUOTAS
          // console.error(`IF 3: ahora monto_descontar = ${montoDescontarTmp}`);
        }

        this.cuotaAfectadasDetalle += ` ${ cuota.numero_cuota }`;
      }

    this.form.get('detalleDescuento').setValue(this.cuotaAfectadasDetalle);

    pos++;
    }
  }


  guardar() {
    if (parseFloat(this.form.get('montoDescuento').value) > 0) {
      let montoDescontar = this.form.get('montoDescuento').value;
      const ID_CLIENTE = this.form.get('clienteID').value;
      for (const cuota of this.prestamoCliente.datos_prestamo.cuotas) {
        const montoPagar = (cuota.monto_cuota - cuota.total_pagado);
        cuota.ID_CLIENTE = ID_CLIENTE;
        if ( montoDescontar >= 1 && cuota.estado !== 2 ) {
          if (montoDescontar >= montoPagar) {
            cuota.monto_descontar = montoPagar;
            cuota.estado = 2;
            cuota.mora = 0;
            cuota.cuotaAfectadasDetalle = this.form.get('detalleDescuento').value;
            cuota.ID_EMPLEADO = this.empleadoService.datosEmpleado.ID_EMPLEADO;
            montoDescontar -= montoPagar; // EN  0 PARA QUE NO SIGA DESCONTANDO CUOTAS
          } else {
            cuota.monto_descontar = montoDescontar;
            cuota.cuotaAfectadasDetalle = this.form.get('detalleDescuento').value;
            cuota.ID_EMPLEADO = this.empleadoService.datosEmpleado.ID_EMPLEADO;
            montoDescontar = 0;
            break;
          }
        }
      }
      const documentos = (<FormArray> this.form.get('documentos')).controls;
      this.prestamoService.descuentoCuotas(
        this.prestamoCliente.datos_prestamo.cuotas,
        this.form.get('detalleDescuento').value,
        documentos
      ).subscribe(res => {
        this.activeModal.close( res ); // return cuotas actualizadas
      }, err => {
        if (err.status == 403) {
          this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
          'red',
          'modern',
          false,
          'fa fa-file-text');
        }
      });
    }
  }

  loadImage() {
    const el = this.file.nativeElement;
    el.click();
    el.onchange = (evt) => {
      const tgt = evt.target || window.event.srcElement,
      files: File[] = tgt.files;
      // FileReader support
      if (files.length) {
        for (const file of files) {
          (<FormArray>this.form.get('documentos')).push(
            new FormGroup({
              nombre: new FormControl(file.name),
              peso: new FormControl(this.helper.tamanoArchivo(file.size)),
              extension: new FormControl(this.helper.tipoArchivo(file.name).toUpperCase()),
              _file: new FormControl(file)
            })
          );
        }
      }
    };
  }

  removeFile(i) {
    (<FormArray> this.form.get('documentos')).controls.splice(i, 1);
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/descuento-cuota/descuento-cuota.component.ts